import { Modal as AntdModal } from "antd";
import classNames from "classnames";
import React from "react";

import SVGIcon from "../Images/SVGIcon";
import styles from "./style.module.css";

const Modal = ({
  children,
  maskStyle = { background: "rgba(0, 0, 0, 0.7)" },
  className,
  centered = true,
  dataTestId = "Modal",
  closeOnOutsideClick = false,
  closeIconClassName,
  showCloseIcon = true,
  ...rest
}) => {
  return (
    <AntdModal
      {...rest}
      centered={centered}
      maskClosable={closeOnOutsideClick}
      maskStyle={maskStyle}
      className={classNames(styles.container, className)}
      closeIcon={
        <SVGIcon
          src="components/v2/Modal/close.svg"
          data-testid={`${dataTestId}-close-icon`}
          className={classNames(closeIconClassName, styles.closeIcon)}
        />
      }
      closable={showCloseIcon}
      modalRender={(modal) => (
        <div className={styles.frame}>
          <span className={styles.tickTR} aria-hidden="true" />
          <span className={styles.tickBL} aria-hidden="true" />
          {modal}
        </div>
      )}
    >
      {children}
    </AntdModal>
  );
};

export default Modal;
